import { AgGridTable } from '@shared/components/ui/AgGridTable';
import type { ColDef } from 'ag-grid-community';
import type { WalletTransaction } from '../../models/Wallet';

interface WalletAgGridTableProps {
  transactions: WalletTransaction[];
  columnDefs: ColDef[];
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
}

export const WalletAgGridTable = ({
  transactions,
  columnDefs,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
}: WalletAgGridTableProps) => {
  return (
    <AgGridTable
      data={transactions}
      columnDefs={columnDefs}
      height="calc(100vh - 280px)"
      rowHeight={64}
      enableSelection={false}
      suppressAggFuncInHeader={true}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
    />
  );
};
